<h2 mat-dialog-title>Re-route lineage of {{ tableName(data.parentTableId) }}</h2>
<div mat-dialog-content>
  <p class="text-muted">
    Moves part of the lineage of several flattened columns at once. Only the flattened columns change - relationships are not created or edited, so the
    new hops must already exist as flatten relationships. ADMs are not regenerated by this - use <b>Regenerate affected ADMs</b> afterwards, once all your changes are made.
  </p>

  <b>1. Lineage to change</b>
  <div class="row">
    <div class="col-md-12">
      <mat-form-field class="full-width"><mat-label>Take the segment from this lineage</mat-label>
        <mat-select [value]="referenceColumnId" (selectionChange)="onReferenceChange($event.value)">
          <mat-option *ngFor="let g of lineageGroups; trackBy: trackGroup" [value]="g.column.admTableColumnId">{{ lineageLabel(g.column.flattenRelationshipPath) }} ({{ g.count }} column{{ g.count === 1 ? "" : "s" }})</mat-option>
        </mat-select></mat-form-field>
    </div>
  </div>
  <div class="row" *ngIf="referenceColumnId !== null">
    <div class="col-md-6">
      <mat-form-field class="full-width"><mat-label>Replace from hop</mat-label>
        <mat-select [(value)]="fromHop" (selectionChange)="onSegmentChange()">
          <mat-option *ngFor="let id of referenceHops; let i = index" [value]="i">{{ i + 1 }}. {{ hopLabel(id) }}</mat-option>
        </mat-select></mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field class="full-width"><mat-label>through hop</mat-label>
        <mat-select [(value)]="throughHop" (selectionChange)="onSegmentChange()">
          <ng-container *ngFor="let id of referenceHops; let i = index"><mat-option *ngIf="i >= fromHop" [value]="i">{{ i + 1 }}. {{ hopLabel(id) }}</mat-option></ng-container>
        </mat-select></mat-form-field>
    </div>
  </div>

  <ng-container *ngIf="oldSegment.length > 0">
    <b>2. Replace with</b>
    <div class="text-muted" style="margin-bottom: 4px">Replacing: <span *ngFor="let id of oldSegment; let last = last">{{ hopLabel(id) }}<span *ngIf="!last">, </span></span></div>
    <ol style="margin: 6px 0">
      <li *ngFor="let id of newSegment">{{ hopLabel(id) }}</li>
    </ol>
    <div class="row">
      <div class="col-md-8">
        <mat-form-field class="full-width"><mat-label>Add next step</mat-label>
          <mat-select (selectionChange)="addStep($event.value)">
            <mat-option *ngFor="let r of nextRelationships" [value]="r.admRelationshipId">{{ hopLabel(r.admRelationshipId) }}<span class="text-muted"> (relationship {{ r.admRelationshipId }}{{ r.kind === 1 ? "" : ", not a flatten relationship" }})</span></mat-option>
          </mat-select></mat-form-field>
      </div>
      <div class="col-md-4" style="margin-top: 10px"><button mat-raised-button class="piButton" (click)="removeLastStep()" [disabled]="newSegment.length === 0">Remove last step</button></div>
    </div>

    <b>3. Columns to move</b>
    <div>
      <mat-checkbox [checked]="applyToAll" (change)="onApplyToAllChange($event.checked)">
        Apply to ALL flattened columns of {{ tableName(data.parentTableId) }} that pass through the hops being replaced ({{ candidates.length }})
      </mat-checkbox>
      <div class="text-muted" style="font-size: 90%">Optional. Leave off to move only the columns ticked below.</div>
    </div>
    <table class="table table-sm">
      <tr><th></th><th>Output name</th><th>Current lineage</th></tr>
      <tr *ngFor="let c of candidates" [style.opacity]="c.retired ? 0.5 : 1">
        <td><mat-checkbox [checked]="applyToAll || picked.has(c.admTableColumnId)" [disabled]="applyToAll" (change)="toggleColumn(c.admTableColumnId, $event.checked)"></mat-checkbox></td>
        <td>{{ c.outputName }}</td>
        <td>{{ lineageLabel(c.flattenRelationshipPath) }}</td>
      </tr>
    </table>
  </ng-container>

  <div *ngIf="error" class="text-danger" style="margin: 8px 0">{{ error }}</div>

  <ng-container *ngIf="preview">
    <b>Preview</b>
    <table class="table table-sm">
      <tr><th>Output name</th><th>Before</th><th>After</th></tr>
      <tr *ngFor="let c of preview.changes"><td>{{ c.outputName }}</td><td>{{ c.oldLineage }}</td><td>{{ c.newLineage }}</td></tr>
    </table>
    <div *ngFor="let i of preview.issues" [class.text-danger]="i.severity === 1" [class.text-muted]="i.severity !== 1">
      {{ i.severity === 1 ? "Error" : "Warning" }}: {{ i.subject }} - {{ i.message }}
    </div>
    <div *ngIf="!hasErrors" class="text-muted">{{ preview.affectedLayoutCount }} ADM layout(s) use these columns and will need regenerating afterwards (not done automatically).</div>
    <div *ngIf="hasErrors" class="text-danger"><b>Fix the errors above first - nothing has been changed.</b></div>
  </ng-container>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onPreview()" [disabled]="!canPreview">Preview</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onApply()" [disabled]="!canApply">Apply</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
